<app-compose-mail appendTo='body' style="z-index: 9999999;"></app-compose-mail>
<mat-card>

    <mat-card-content>


        <div style="background: url('../../assets/img/morceau/titre.png');height: 60px; background-size: 100% 100%;
        width: 100%;color: #2F4395; font-size: 18px;">

            <div style="float: left;margin-top:5px;">
                <img src="../../assets/img/morceau/5.png" height="40">
                Logistique
            </div>
            <div style="float: right; cursor: pointer;" (click)="gotoLogistiques()">
                <img src="../../assets/img/morceau/edit.png">
            </div>

        </div>

        <div class="content2">


            <div class="row">

                <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">

                    <mat-form-field class="example-full-width">
                        <input matInput placeholder="Materiels.S" [value]='nbrMaterielSpecifiqueS'>
                    </mat-form-field>
                </div>

                <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">
                    <mat-form-field class="example-full-width">
                        <input matInput placeholder="Publicité" [value]='nbrPubliciteS'>
                    </mat-form-field>

                </div>
            </div>

            <div class="row">

                <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">
                    <mat-form-field class="example-full-width">
                        <input matInput placeholder="Badges" [value]="nbrBadge">
                    </mat-form-field>
                </div>

                <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">
                    <mat-form-field class="example-full-width">
                        <input matInput placeholder="Delgates" [value]='nbrDelegateS' (click)="clickedMe()">
                    </mat-form-field>
                </div>
            </div>

            <div class="row">

                <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">
                    <mat-form-field class="example-full-width">
                        <input matInput placeholder="Invitations Visa" (click)="visibleVisa=true" [value]='nbrVisa'>
                    </mat-form-field>
                </div>

                <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">
                    <mat-form-field class="example-full-width">
                        <input matInput (click)="visibleDouane=true" [value]='nbrAttestation'
                            placeholder="Attestaion douane">
                    </mat-form-field>

                </div>
            </div>

        </div>

    </mat-card-content>
</mat-card>


<p-dialog [modal]="true" appendTo='body' [baseZIndex]="'9999999999'" [closable]='false' [(visible)]="visibleDouane"
    [style]="{width: '1000px', minWidth: '800px', minHeight: '400px'}" [minY]="100">

    <p-header>
        <div
            style="background: url('../../assets/img/morceau/titre.png');height: 60px; background-size: 100% 100%; width: 100%;color: #2F4395; font-size: 18px;">

            <div style="float: left;margin-top:5px; font-weight: normal!important;">

                Attestation Douanes
            </div>
            <div style="float: right; cursor: pointer;">


                <button mat-icon-button (click)="sendDouane()" style="width: 150px;" label="Envoyer">
                    <mat-icon>email</mat-icon>Envoyer
                </button>

                <button mat-icon-button (click)="printDouane('pdf')" style="width: 150px;" label="Exporter PDF"
                    aria-label="Print douane">
                    <mat-icon style="color: orange;">picture_as_pdf</mat-icon>Exporter PDF
                </button>

                <button mat-icon-button (click)="printDouane('doc')" style="width: 150px;" value="Exporter Word"
                    aria-label="Print douane">
                    <mat-icon> g_translate</mat-icon>Exporter Word
                </button>


                <mat-slide-toggle [(ngModel)]="isSigner">
                    <span style="font-weight: normal;">Signature</span> </mat-slide-toggle>

                <mat-icon (click)="visibleDouane=false"
                    style="background-color: red!important;color: white!important;  margin-left: 50px;" class="mat-18">
                    close</mat-icon>


            </div>

        </div>
    </p-header>

    <mat-card-content style="height: 400px!important;">
        <div>


            <div style=" background: #F9F9F9;">




                <p-table [value]="douanes" [(selection)]="selectedDouane" dataKey="id_certificat_douane">
                    <ng-template pTemplate="header" style="background: #E1F3FE!important;">
                        <tr style="background: #E1F3FE!important;">
                            <th style="width: 3em"></th>
                            <th>Date d'envoie</th>
                            <th>Raison Social</th>
                            <th>Remarque</th>
                            <th style="width: 5em"></th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-car>
                        <tr>
                        <tr [pSelectableRow]="car">
                            <td>
                                <p-tableRadioButton [value]="car"></p-tableRadioButton>
                            </td>
                            <td>{{car.date_envoie  |  date}}</td>
                            <td pEditableColumn>
                                <p-cellEditor>
                                    <ng-template pTemplate="input">
                                        <input pInputText type="text" (change)='updateDouane(car)'
                                            [(ngModel)]="car.entreprise" required>
                                    </ng-template>
                                    <ng-template pTemplate="output">
                                        {{car.entreprise}}
                                    </ng-template>
                                </p-cellEditor>
                            </td>
                            <td pEditableColumn>
                                <p-cellEditor>
                                    <ng-template pTemplate="input">
                                        <input pInputText type="text" (change)='updateDouane(car)'
                                            [(ngModel)]="car.voie" required>
                                    </ng-template>
                                    <ng-template pTemplate="output">
                                        {{car.voie}}
                                    </ng-template>
                                </p-cellEditor>
                            </td>

                            <td>
                                <button class="ui-button-danger" pButton (click)="deleteDouane(car)" icon="pi pi-trash"
                                    style="margin-right: .5em">

                                </button>
                            </td>


                        </tr>
                    </ng-template>
                </p-table>







            </div>

        </div>


    </mat-card-content>




    <p-button icon="pi pi-add" label="Ajouter" (click)="addDouane( )"></p-button>

</p-dialog>



<p-dialog [modal]="true" appendTo='body' [baseZIndex]="'9999999999'" *ngIf="visibleVisa" [closable]='false'
    [(visible)]="visibleVisa" [style]="{width: '1000px', minWidth: '800px', minHeight: '400px'}" [minY]="100">

    <p-header>
        <div
            style="background: url('../../assets/img/morceau/titre.png');height: 60px; background-size: 100% 100%; width: 100%;color: #2F4395; font-size: 18px;">

            <div style="float: left;margin-top:5px; font-weight: normal!important;">

                Invitations Visa
            </div>
            <div style="float: right; cursor: pointer;">




                <button mat-icon-button (click)="printInvitation('pdf','i' )" style="width: 150px;" label="Exporter PDF"
                    aria-label="Print douane">
                    <mat-icon style="color: orange;">picture_as_pdf</mat-icon>Exporter PDF
                </button>

                <button mat-icon-button (click)="printInvitation('doc','i' )" style="width: 150px;"
                    value="Exporter Word" aria-label="Print douane">
                    <mat-icon> g_translate</mat-icon>Exporter Word
                </button>




                <mat-icon (click)="visibleVisa=false"
                    style="background-color: red!important;color: white!important;  margin-left: 50px;" class="mat-18">
                    close</mat-icon>


            </div>

        </div>
    </p-header>

    <mat-card-content style="height: 400px!important;">
        <div>


            <div style=" background: #F9F9F9;">

                <p-table [value]="invitations" [(selection)]="selectedInvitation">
                    <ng-template pTemplate="header">
                        <tr>
                            <th style="width: 3em"></th>
                            <th>Entreprise</th>
                            <th>Nom</th>
                            <th>Nationalite</th>
                            <th>Email</th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-car>
                        <tr [pSelectableRow]="car">
                            <td>
                                <p-tableRadioButton [value]="car"></p-tableRadioButton>
                            </td>
                            <td>{{car.participant}}</td>
                            <td>{{car.nom}} {{car.prenom}}</td>
                  

                            <td pEditableColumn>
                                <p-cellEditor>
                                    <ng-template pTemplate="input">
                                        <input pInputText type="text" (change)='updateInviation(car)'
                                            [(ngModel)]="car.nationalite" required>
                                    </ng-template>
                                    <ng-template pTemplate="output">
                                        {{car.nationalite}}
                                    </ng-template>
                                </p-cellEditor>
                            </td>

                            <td>{{car.email}}</td>

                        </tr>
                    </ng-template>
                </p-table>

            </div>
        </div>

    </mat-card-content>

</p-dialog>